import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "body-wrapper"
}
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = { class: "input-row" }
const _hoisted_7 = { class: "input-wr" }
const _hoisted_8 = {
  key: 1,
  class: "modal-wrapper succeded"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $props.isOpen,
    onClose: $setup.close,
    classes: "modal--wrapper2"
  }, {
    content: _withCtx(() => [
      (!$setup.redirectUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            ($setup.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal-title" }, "Create Contract", -1)),
                  _cache[4] || (_cache[4] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "info" }, [
                      _createElementVNode("p", null, "The form is generated using the \"House & Land Sales\" template provided by REI/Realworks.")
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("form", {
                      class: "default-form option-form",
                      onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _cache[2] || (_cache[2] = _createElementVNode("label", { class: "label" }, "Name", -1)),
                            _withDirectives(_createElementVNode("input", {
                              class: "input",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formName) = $event))
                            }, null, 512), [
                              [_vModelText, $setup.formName]
                            ])
                          ])
                        ])
                      ])
                    ], 32),
                    _createElementVNode("div", { class: "buttons-wrapper" }, [
                      _createElementVNode("button", {
                        class: "button default outlined primary",
                        onClick: $setup.close
                      }, "Cancel"),
                      _createElementVNode("button", {
                        class: "button default primary cancel",
                        onClick: $setup.onSubmit
                      }, "Generate")
                    ])
                  ])
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", { class: "body-wrapper" }, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-title" }, "Contract Generated", -1)),
              _createElementVNode("div", { class: "modal-body" }, [
                _createElementVNode("div", { class: "buttons-wrapper" }, [
                  _createElementVNode("button", {
                    class: "button default outlined primary",
                    onClick: $setup.resetForm
                  }, "Reset"),
                  _createElementVNode("button", {
                    class: "button default primary",
                    onClick: $setup.goToPreview
                  }, "Go To Preview")
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["is-open"]))
}